import { render, staticRenderFns } from "./AlertHistory.vue?vue&type=template&id=4748cfe2&scoped=true&"
import script from "./AlertHistory.vue?vue&type=script&lang=js&"
export * from "./AlertHistory.vue?vue&type=script&lang=js&"
import style0 from "./AlertHistory.vue?vue&type=style&index=0&id=4748cfe2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4748cfe2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VDataTable,VIcon,VProgressCircular,VTextField})
